export default __webpack_public_path__ + "static/media/Logo-small.6f5a265f.svg";